import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'components/atoms/form';
import { setDirtyState } from 'data/templates';
import { useStatusUpdatesTemplatesContext } from '../context';
import { ConfigSwitches } from './config-switches';
import { FrequencySelector } from './frequency-selector';
import { ProjectsSelector } from './projects-selector';
import { Content } from './styles';

export const StatusupdateTemplateConfiguration: FC = () => {
  const dispatch = useDispatch();
  const {
    frequency,
    projectTarget,
    isPrivate,
    isPublished,
    projectFilter,
    setPublished,
    setPrivate,
    onProjectTargetChange,
    updateFrequency,
  } = useStatusUpdatesTemplatesContext();

  const onUpdateFrequency = (selected) => {
    if (updateFrequency) {
      updateFrequency({
        ...frequency,
        ...selected,
      });
    }
  };

  const templateContext = useStatusUpdatesTemplatesContext();

  const setDirtyAndCallback = useCallback(
    (fn, ...args) => {
      dispatch(
        setDirtyState({
          id: templateContext.templateId ?? 0,
          _state: true,
        }),
      );
      fn(...args);
    },
    [dispatch, templateContext.templateId],
  );

  const configSwitches = {
    publish: {
      isPublished,
      setPublished: (...args) => setDirtyAndCallback(setPublished, ...args),
    },
    private: {
      isPrivate,
      setPrivate: (...args) => setDirtyAndCallback(setPrivate, ...args),
    },
  };

  return (
    <Content>
      <Form layout="vertical">
        <ConfigSwitches switches={configSwitches} />
        <ProjectsSelector
          projectFilter={projectFilter}
          projectTarget={projectTarget}
          onProjectTargetChange={(...args) =>
            setDirtyAndCallback(onProjectTargetChange, ...args)
          }
        />
        <FrequencySelector
          onFrequencyUpdate={(...args) =>
            setDirtyAndCallback(onUpdateFrequency, ...args)
          }
          frequency={frequency}
        />
      </Form>
    </Content>
  );
};
